export interface ArticleSection {
  h2Key: string;
  paragraphKeys: string[];
  stepKeys?: string[];
}

export interface PillarArticle {
  slug: string;
  keyPrefix: string;
  excerptKey: string;
  coverImage: string;
  sections: ArticleSection[];
  faqCount: number;
}

export const guideArticle: PillarArticle = {
  slug: "allchinabuy-spreadsheet-guide",
  keyPrefix: "article",
  excerptKey: "articles.card.excerpt",
  coverImage:
    "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20a%20laptop%20displaying%20an%20organized%20spreadsheet%20table%20surrounded%20by%20a%20folded%20beige%20hoodie%20sneakers%20and%20a%20notebook%2C%20warm%20neutral%20tones%2C%20soft%20natural%20window%20light%2C%20minimal%20editorial%20flat%20lay%2C%20fresh%20airy%20aesthetic&width=900&height=560&seq=cover-guide&orientation=landscape",
  sections: [
    { h2Key: "article.s1.h2", paragraphKeys: ["article.s1.p1", "article.s1.p2"] },
    { h2Key: "article.s2.h2", paragraphKeys: ["article.s2.p1"] },
    {
      h2Key: "article.s3.h2",
      paragraphKeys: ["article.s3.p1"],
      stepKeys: ["article.s3.step1", "article.s3.step2", "article.s3.step3", "article.s3.step4", "article.s3.step5"],
    },
    { h2Key: "article.s4.h2", paragraphKeys: ["article.s4.p1"] },
    { h2Key: "article.s5.h2", paragraphKeys: ["article.s5.p1"] },
    { h2Key: "article.s6.h2", paragraphKeys: ["article.s6.p1"] },
    { h2Key: "article.s7.h2", paragraphKeys: ["article.s7.p1"] },
  ],
  faqCount: 5,
};

const threeSections = (prefix: string): ArticleSection[] => [
  { h2Key: `${prefix}.s1.h2`, paragraphKeys: [`${prefix}.s1.p1`, `${prefix}.s1.p2`] },
  { h2Key: `${prefix}.s2.h2`, paragraphKeys: [`${prefix}.s2.p1`] },
  { h2Key: `${prefix}.s3.h2`, paragraphKeys: [`${prefix}.s3.p1`] },
];

export const pillarArticles: PillarArticle[] = [
  guideArticle,
  {
    slug: "allchinabuy-review",
    keyPrefix: "allchinabuy-review",
    excerptKey: "allchinabuy-review.excerpt",
    coverImage:
      "https://readdy.ai/api/search-image?query=Editorial%20desk%20scene%20with%20a%20laptop%20showing%20review%20star%20ratings%20and%20a%20spreadsheet%20surrounded%20by%20shopping%20parcels%20and%20a%20notebook%2C%20warm%20neutral%20tones%2C%20soft%20natural%20light%2C%20minimal%20business%20flat%20lay%20photography&width=900&height=560&seq=cover-review&orientation=landscape",
    sections: threeSections("allchinabuy-review"),
    faqCount: 3,
  },
  {
    slug: "allchinabuy-shipping-cost",
    keyPrefix: "allchinabuy-shipping-cost",
    excerptKey: "allchinabuy-shipping-cost.excerpt",
    coverImage:
      "https://readdy.ai/api/search-image?query=Flat%20lay%20of%20a%20cardboard%20shipping%20box%20with%20packing%20tape%20a%20scale%20and%20a%20calculator%20on%20a%20light%20wooden%20desk%2C%20warm%20soft%20lighting%2C%20minimal%20logistics%20e-commerce%20photography%20with%20negative%20space&width=900&height=560&seq=cover-shipping-cost&orientation=landscape",
    sections: threeSections("allchinabuy-shipping-cost"),
    faqCount: 3,
  },
  {
    slug: "allchinabuy-coupon",
    keyPrefix: "allchinabuy-coupon",
    excerptKey: "allchinabuy-coupon.excerpt",
    coverImage:
      "https://readdy.ai/api/search-image?query=Colorful%20discount%20coupon%20cards%20and%20a%20smartphone%20showing%20a%20promo%20code%20on%20a%20soft%20pastel%20background%2C%20bright%20airy%20lighting%2C%20clean%20minimal%20e-commerce%20marketing%20photography&width=900&height=560&seq=cover-coupon&orientation=landscape",
    sections: threeSections("allchinabuy-coupon"),
    faqCount: 3,
  },
  {
    slug: "allchinabuy-warehouse",
    keyPrefix: "allchinabuy-warehouse",
    excerptKey: "allchinabuy-warehouse.excerpt",
    coverImage:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20warehouse%20interior%20with%20organized%20shelves%20of%20cardboard%20boxes%20and%20a%20clipboard%2C%20soft%20industrial%20lighting%2C%20clean%20logistics%20photography%20with%20depth%20and%20order&width=900&height=560&seq=cover-warehouse&orientation=landscape",
    sections: threeSections("allchinabuy-warehouse"),
    faqCount: 3,
  },
  {
    slug: "allchinabuy-qc",
    keyPrefix: "allchinabuy-qc",
    excerptKey: "allchinabuy-qc.excerpt",
    coverImage:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20magnifying%20glass%20over%20a%20folded%20garment%20with%20a%20QC%20checklist%20on%20a%20light%20table%2C%20warm%20diffused%20lighting%2C%20minimal%20quality%20inspection%20product%20photography&width=900&height=560&seq=cover-qc&orientation=landscape",
    sections: threeSections("allchinabuy-qc"),
    faqCount: 3,
  },
  {
    slug: "allchinabuy-legit",
    keyPrefix: "allchinabuy-legit",
    excerptKey: "allchinabuy-legit.excerpt",
    coverImage:
      "https://readdy.ai/api/search-image?query=A%20padlock%20and%20a%20shield%20icon%20beside%20a%20smartphone%20showing%20a%20verified%20badge%20on%20a%20soft%20green%20background%2C%20bright%20clean%20lighting%2C%20minimal%20trust%20and%20safety%20concept%20photography&width=900&height=560&seq=cover-legit&orientation=landscape",
    sections: threeSections("allchinabuy-legit"),
    faqCount: 3,
  },
  {
    slug: "allchinabuy-shipping",
    keyPrefix: "allchinabuy-shipping",
    excerptKey: "allchinabuy-shipping.excerpt",
    coverImage:
      "https://readdy.ai/api/search-image?query=Open%20world%20map%20with%20small%20parcel%20icons%20and%20a%20route%20line%20on%20a%20light%20desk%20with%20a%20coffee%20cup%2C%20warm%20natural%20lighting%2C%20minimal%20shipping%20logistics%20concept%20flat%20lay%20photography&width=900&height=560&seq=cover-shipping&orientation=landscape",
    sections: threeSections("allchinabuy-shipping"),
    faqCount: 3,
  },
  {
    slug: "allchinabuy-product-research",
    keyPrefix: "allchinabuy-product-research",
    excerptKey: "allchinabuy-product-research.excerpt",
    coverImage:
      "https://readdy.ai/api/search-image?query=Desk%20with%20a%20laptop%20showing%20product%20grids%20a%20notebook%20with%20handwritten%20notes%20and%20small%20fashion%20items%2C%20warm%20natural%20lighting%2C%20minimal%20research%20workspace%20flat%20lay%20photography&width=900&height=560&seq=cover-research&orientation=landscape",
    sections: threeSections("allchinabuy-product-research"),
    faqCount: 3,
  },
  {
    slug: "allchinabuy-haul",
    keyPrefix: "allchinabuy-haul",
    excerptKey: "allchinabuy-haul.excerpt",
    coverImage:
      "https://readdy.ai/api/search-image?query=Large%20open%20cardboard%20box%20overflowing%20with%20folded%20clothes%20sneakers%20and%20accessories%20on%20a%20light%20floor%2C%20bright%20natural%20lighting%2C%20minimal%20unboxing%20haul%20flat%20lay%20photography&width=900&height=560&seq=cover-haul&orientation=landscape",
    sections: threeSections("allchinabuy-haul"),
    faqCount: 3,
  },
  {
    slug: "allchinabuy-safety",
    keyPrefix: "allchinabuy-safety",
    excerptKey: "allchinabuy-safety.excerpt",
    coverImage:
      "https://readdy.ai/api/search-image?query=A%20shield%20and%20lock%20icon%20on%20a%20laptop%20screen%20with%20a%20subtle%20warning%20sign%20on%20a%20soft%20neutral%20background%2C%20clean%20bright%20lighting%2C%20minimal%20online%20safety%20concept%20photography&width=900&height=560&seq=cover-safety&orientation=landscape",
    sections: threeSections("allchinabuy-safety"),
    faqCount: 3,
  },
];